import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const DocumentMastersListPage = lazy(() =>
  import("@/modules/docs").then((m) => ({ default: m.DocumentMastersListPage })),
);
const DocumentMasterDetailPage = lazy(() =>
  import("@/modules/docs").then((m) => ({ default: m.DocumentMasterDetailPage })),
);
const DocumentMasterDesignPage = lazy(() =>
  import("@/modules/docs").then((m) => ({ default: m.DocumentMasterDesignPage })),
);
const FormInstancesListPage = lazy(() =>
  import("@/modules/docs").then((m) => ({ default: m.FormInstancesListPage })),
);
const SavedDocumentsListPage = lazy(() =>
  import("@/modules/docs").then((m) => ({ default: m.SavedDocumentsListPage })),
);
const SavedDocumentDetailPage = lazy(() =>
  import("@/modules/docs").then((m) => ({ default: m.SavedDocumentDetailPage })),
);

export const docsRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.DocMasterList, PermissionCodes.DocMasterManage,
                  PermissionCodes.DocInstanceList, PermissionCodes.DocInstanceManage,
                  PermissionCodes.DocAttachmentList, PermissionCodes.DocAttachmentManage,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "doc/masters",
                element: (
                  <LazyPage>
                    <DocumentMastersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "doc/masters/:docCode",
                element: (
                  <LazyPage>
                    <DocumentMasterDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "doc/masters/:docCode/design",
                element: (
                  <LazyPage>
                    <DocumentMasterDesignPage />
                  </LazyPage>
                ),
              },
              {
                path: "doc/instances",
                element: (
                  <LazyPage>
                    <FormInstancesListPage />
                  </LazyPage>
                ),
              },
              {
                path: "doc/documents",
                element: (
                  <LazyPage>
                    <SavedDocumentsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "doc/documents/:attachmentId",
                element: (
                  <LazyPage>
                    <SavedDocumentDetailPage />
                  </LazyPage>
                ),
              },
            ],
          },
];
